import React from 'react'
import { useTranslation } from 'react-i18next'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useCopyToClipboard } from '~/hooks/useCopyToClipboard'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { type DocumentReport } from '../hooks/useDocumentReportsInfiniteQuery'

export type ShareButtonProps = {
  documentReport: DocumentReport
}

export const ShareButton = ({ documentReport }: ShareButtonProps) => {
  const { t } = useTranslation()
  const brandAccountId = useBrandAccountId()
  const copyToClipboard = useCopyToClipboard()
  const logEvent = useLogEvent()
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    const url = `${window.location.origin}${compile('documentReportEdit', {
      brandAccountId,
      documentReportId: documentReport.id,
    })}`
    copyToClipboard(url, {
      notificationText: t('documentreport_title_url_copied_to_clipboard', {
        documentReport,
      }),
    })
    logEvent('Share document')
  }, [brandAccountId, copyToClipboard, documentReport, logEvent, t])

  return (
    <StyledButton fillMode="outline" icon="share" onClick={handleClick}>
      {t('share')}
    </StyledButton>
  )
}
